/** Locale helpers for the Kenyan market (SRS §8.4). */
import { KE_PHONE_REGEX, YOUTUBE_ID_REGEX } from './types.js';
/** SRS §8.4 mandates the exact form `KES X,XXX.XX`. */
export function formatKES(amount) {
    const n = typeof amount === 'string' ? Number(amount) : amount;
    if (!Number.isFinite(n))
        return 'KES 0.00';
    return `KES ${n.toLocaleString('en-KE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;
}
/** All customer-visible timestamps render in Africa/Nairobi (UTC+3), per SRS §8.4. */
export function formatNairobiDate(iso, opts = { dateStyle: 'medium', timeStyle: 'short' }) {
    return new Intl.DateTimeFormat('en-KE', { timeZone: 'Africa/Nairobi', ...opts }).format(new Date(iso));
}
/** Normalises 07…/01…/+254… to the E.164 form we store and send to Daraja/WhatsApp. */
export function normalizeKenyanPhone(input) {
    const cleaned = input.replace(/[\s-]/g, '');
    if (!KE_PHONE_REGEX.test(cleaned))
        return null;
    return cleaned.startsWith('+254') ? cleaned : `+254${cleaned.slice(1)}`;
}
/**
 * Extracts the 11-char video ID from any YouTube URL form (SRS Appendix B.1).
 * Accepts a bare ID too, so admins can paste either.
 */
export function extractYoutubeId(url) {
    if (!url)
        return null;
    const trimmed = url.trim();
    if (YOUTUBE_ID_REGEX.test(trimmed))
        return trimmed;
    const patterns = [
        /[?&]v=([a-zA-Z0-9_-]{11})/, // youtube.com/watch?v=ID
        /youtu\.be\/([a-zA-Z0-9_-]{11})/, // youtu.be/ID
        /\/embed\/([a-zA-Z0-9_-]{11})/, // youtube.com/embed/ID
        /\/shorts\/([a-zA-Z0-9_-]{11})/, // youtube.com/shorts/ID
    ];
    for (const re of patterns) {
        const m = trimmed.match(re);
        if (m?.[1])
            return m[1];
    }
    return null;
}
/** URL-safe slug used for product and category paths (SRS §7.3). */
export function slugify(input) {
    return input
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 255);
}
/** Builds the variant URL from the stored `path` prefix + naming convention (SRS §7.4). */
export function imageUrl(path, displayOrder, variant) {
    const prefix = path.endsWith('/') ? path : `${path}/`;
    return `${prefix}${displayOrder}-${variant}.webp`;
}
//# sourceMappingURL=format.js.map